import { create } from "zustand";
import { useAddToColorCollectionModalStore } from "./add-to-color-collection-modal-store";
import { useEditColorCollectionsStore } from "./edit-color-collections-store";
import { useDeleteAccountModalStore } from "./delete-account-modal-store";
import { useMySavedColorsModalStore } from "./my-saved-colors-modal-store";
import { useMyStyleModalStore } from "./my-style-modal-store";
import { useAddSavedColorsToCollectionModalStore } from "./add-saved-colors-to-collection-modal-store";
import { useInviteFriendModalStore } from "./invite-friend-modal-store";
import { useProfileImageModalStore } from "./profile-image-modal-store";

export const useHeroImageModalStore = create((set) => ({
  isModalOpen: false,
  openModal: () => {
    useAddToColorCollectionModalStore.getState().closeModal();
    useEditColorCollectionsStore.getState().closeModal();
    useDeleteAccountModalStore.getState().closeModal();
    useMySavedColorsModalStore.getState().closeModal();
    useMyStyleModalStore.getState().closeModal();
    useAddSavedColorsToCollectionModalStore.getState().closeModal();
    useInviteFriendModalStore.getState().closeModal();
    useProfileImageModalStore.getState().closeModal();

    set({ isModalOpen: true });
  },
  closeModal: () => set({ isModalOpen: false }),
  updateIsModalOpen: (isModalOpen) => set({ isModalOpen }),
}));
